import { VISITOR_INFO, VISITS } from '@mm/api-routes';
import Controller from './Controller';

export type VisitModel = {
  incognito: boolean;
  ipAddress: string;
  ipLocation: {
    city: { name: string };
    country: { code: string; name: string };
    latitude: number;
    longitude: number;
  };
  visitedAt: string;
  firstVisitAt: string;
};

export type UserInfoModel = {
  name: string;
  email: string;
};

export default class VisitsController extends Controller {
  static async getVisits(visitorId: string): Promise<VisitModel[]> {
    return super.get(VISITS, { visitor_id: visitorId });
  }

  static async getUserInfo(
    visitorId: string,
    utmCampaign: string,
  ): Promise<UserInfoModel> {
    return super.get(VISITOR_INFO, {
      visitor_id: visitorId,
      utm_campaign: utmCampaign,
    });
  }
}
